import React, { useEffect, useState } from "react";
import AppShell from "../../components/AppShell";
import { api, formatErr } from "../../lib/api";
import { localToday, LEVEL_COLOR } from "../../lib/wellness";
import { WellnessForm } from "../../components/wellness/WellnessForm";
import { TodayScreen } from "../../components/wellness/TodayScreen";

const History = ({ items }) => (
  <div className="qv-card-app" style={{ padding: 16, marginTop: 18 }} data-testid="wb-my-history">
    <div className="qv-overline" style={{ marginBottom: 8 }}>Tus últimos días</div>
    {items.map((c) => (
      <div key={c.id} style={{ display: "flex", justifyContent: "space-between", fontSize: 13, padding: "6px 0", borderTop: "1px solid rgba(255,255,255,0.06)" }}>
        <span>{new Date(`${c.local_date}T12:00:00`).toLocaleDateString("es-ES", { weekday: "short", day: "numeric", month: "short" })}</span>
        <span style={{ color: LEVEL_COLOR[c.today.level] }}>{c.today.level_label}</span>
        <span style={{ color: "#a3a3a3" }}>Sueño {c.sleep_hours} h · Dolor {c.pain}/10</span>
      </div>
    ))}
  </div>
);

export default function ClientWellness() {
  const [st, setSt] = useState(null);
  const [hist, setHist] = useState([]);
  const [err, setErr] = useState(null);
  const today = localToday();
  const loadHist = () => api.get("/me/wellness/history?limit=14").then((r) => setHist(r.data)).catch(() => {});
  useEffect(() => {
    api.get(`/me/wellness/status?local_date=${today}`).then((r) => setSt(r.data)).catch((e) => setErr(formatErr(e)));
    loadHist();
  }, [today]);
  const done = st?.checkin;
  return (
    <AppShell>
      <div className="qv-page-head" data-testid="client-wellness">
        <div className="label">{new Date().toLocaleDateString("es-ES", { weekday: "long", day: "numeric", month: "long" })}</div>
        <h1>{done ? "Hoy toca esto" : "Cuestionario diario"}</h1>
        {!done && <p className="sub">Menos de un minuto. Con tus respuestas ajustamos cómo enfocar la sesión de hoy.</p>}
      </div>
      <div style={{ maxWidth: 640 }}>
        {err && <div className="qv-empty">{err}</div>}
        {!st && !err && <div style={{ color: "#a3a3a3" }}>Cargando…</div>}
        {st && !done && <WellnessForm rpeSession={st.rpe_session} onDone={(c) => { setSt({ checkin: c }); loadHist(); window.scrollTo({ top: 0, behavior: "smooth" }); }} />}
        {done && <TodayScreen c={done} />}
        {hist.length > 1 && <History items={hist.filter((c) => c.local_date !== today)} />}
      </div>
    </AppShell>
  );
}
